<template>
  <div class="text-area-container">
    <textarea
      :id="id"
      v-model="value"
      :name="name"
      v-bind="{ ...$attrs, ...(props as InputHTMLAttributes) }"
      class="text-area-input f-utility-14-medium"
      :class="textareaAttributes"
      :disabled="disabled"
      :placeholder="placeHolder"
      @focusin="isFocused = true"
      @focusout="((isFocused = false), validate())"
    ></textarea>
    <label
      v-if="!isFilled"
      :for="name"
      class="text-area-label t-fg-tertiary"
      :class="{ 'f-body-12': isFocused, 'f-utility-14': !isFocused }"
      v-text="label"
    />
    <p-loading
      v-if="loading"
      size="sm"
      :class="assistiveText && 'mb-20'"
      class="text-area-loading"
    />
    <p
      v-if="assistiveText"
      :class="isError && 't-fg-danger'"
      class="f-utility-14 t-fg-tertiary"
      v-text="assistiveText"
    />
  </div>
</template>

<script lang="ts" setup>
import type { InputHTMLAttributes } from 'vue'

const props = defineProps({
  id: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
    required: true,
  },
  assistiveText: {
    type: String,
    default: '',
  },
  placeHolder: {
    type: String,
    default: '',
  },
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const isFocused = ref(false)

const isError = computed<boolean>(() => {
  return !meta.valid && meta.validated
})

const isFilled = computed<boolean>(() => {
  return !!value.value
})

const textareaAttributes = computed(() => {
  return [
    isFocused.value ? 'text-area-input-focus-in' : 'text-area-input-focus-out',
    isError.value && 'text-area-input-error',
    props.disabled && 'text-area-input-disabled',
  ]
})

const name = toRef(props, 'name')
const modelValue = toRef(props, 'modelValue')

const { value, meta, validate } = useField(props.name, undefined, {
  initialValue: modelValue.value,
})

watch(
  () => modelValue.value,
  () => (value.value = modelValue.value),
)
</script>
